<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
    <div>
      <div class="row">
        <div class="col-md-12">
          <h3><i class="fas fa-popcorn"></i> {{ _('Maccsbox results') }}</h3>
        </div>
      </div>
      <div class="row maccsbox-buttons">
        <div class="col-md-10">
          <button class="btn btn-primary" v-on:click="openSendResults"><i class="fas fa-share"></i> {{ _('Send results') }}</button>
        </div>
      </div>
      <Datatable :url="resultsUrl" :sort="sort" :options="tableOptions" ref="datatable" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import components from '~/lib/components'
import formatters from '~/lib/formatters'
import { Datatable, MaccsboxActions, SendMaccsResults } from '#components'
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'

export default {
  data () {
    const $this = this
    const _ = useNuxtApp().$translate
    return {
      sort: [{
        column: 'playdate',
        dir: 'desc'
      }],
      tableOptions: {
        responsiveLayoutCollapseFormatter: this.collapseFormatter(),
        rowFormatter: this.maccsboxRowFormatter(),
        columns: [{
          title: 'ID',
          field: 'id',
          width: 60,
          responsive: 0
        },
        {
          title: _('Play date'),
          field: 'playdate',
          widthGrow: 2,
          responsive: 0
        },
        {
          title: _('Movie name'),
          field: 'filmName',
          widthGrow: 5
        },
        {
          title: _('Theatre name'),
          field: 'theatreName',
          widthGrow: 5
        },
        {
          title: _('Ticket type'),
          field: 'ticketType',
          widthGrow: 5
        },
        {
          title: _('Admissions'),
          field: 'admissions',
          widthGrow: 3
        },
        {
          title: _('Status'),
          field: 'code',
          width: 75,
          responsive: 0
        }],
        initialSort: [{
          column: 'playdate',
          dir: 'desc'
        }],
        rowClick (e, row) {
          $this.selectRow(row)
        }
      },
      movies: []
    }
  },
  mixins: [components, formatters],
  computed: {
    ...mapGetters(['timeFormat']),
    resultsUrl () {
      return this.baseDomain + this.shopId + '/maccsboxlogs.json?apikey=' + this.apiKey
    }
  },
  methods: {
    async selectRow (row) {
      const id = row.getCell('id').getValue()
      let response
      let log
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/maccsboxlogs/' + id + '.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      if (response && response.data) {
        log = response.data
      }
      if (log) {
        this.showModal('actions', MaccsboxActions, {
          props: {
            log: log
          },
          events: {
            resendRequest: this.resendRequest
          },
          width: 800
        })
      } else {
        this.showError(this._('Could not fetch log data'))
      }
    },
    async resendRequest (id) {
      let data = {
        id: id
      }
      let response
      try {
        response = await axios.post(this.baseDomain + this.shopId + '/maccsboxlogs.json?apikey=' + this.apiKey, data)
      } catch (error) {
        return this.showError(this._('Maccsbox request failed'))
      }

      return this.showNotification(this._('Maccsbox request sent'))
    },
    async sendRequest (req) {
      // Check that we have a movie reference
      let response = null

      if(req && !parseInt(req.selectAllMovies)) {
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/products/' + req.selectedMovie.id + '.json?apikey=' + this.apiKey)
        } catch(e) {
          return this.showError(this._('Maccsbox request failed'))
        }
        if(!response.data) {
          return this.showError(this._('Maccsbox request failed'))
        }
        if(!response.data.channeldata.maccsboxref || response.data.channeldata.maccsboxref.trim().length < 5) {
            let d = new Date()
            if(d.getMinutes() < 5) {
              // Next 15 past is fine
              d.setMinutes(15,0,0)
            } else {
              // Wait an hour and then some
              d.setMinutes(0,0,0)
              d.setTime(d.getTime() + (60*60*1000))
              d.setMinutes(15,0,0)
            }
            return this.showError(this._('The Maccsbox reference for the selected movie was not yet obtained. Validate the version information and retry after %1s.').replace('%1s', DateTime.fromMillis(d.getTime()).toFormat(this.timeFormat)))
        }
      }

      let data = {
        moviename: req.selectedMovie.title,
        all: req.selectAllMovies,
        startDate: req.dateStart,
        endDate: req.dateEnd
      }

      try {
        response = await axios.post(this.baseDomain + this.shopId + '/maccsboxlogs.json?apikey=' + this.apiKey, data)
      } catch (error) {
        return this.showError(this._('Maccsbox request failed'))
      }

      return this.showNotification(this._('Maccsbox request sent'))
    },
    openSendResults () {
      this.showModal('sendresults', SendMaccsResults, {
        props: {
          movies: this.movies
        },
        events: {
          sendRequest: this.sendRequest
        },
        width: 800
      })
    },
    async loadMovies () {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/groupedproducts.json?apikey=' + this.apiKey + '&filters[]=%7B"field":"type","type":"%3D","value":"1-4-movie"%7D')
      } catch (error) {
        console.log(error)
      }

      return this.movies = response.data
    },
    reload () {
      this.$refs.datatable.reload()
    }
  },
  components: {
    Datatable,
    MaccsboxActions
  },
  mounted () {
    this.loadMovies()
  }
}
</script>
